import { apiClient, unwrap } from './client';
import type { ApiEnvelope, UserTariff } from './types';

export async function getCurrentTariff(userGUID: string): Promise<UserTariff> {
  const { data } = await apiClient.get<ApiEnvelope<UserTariff>>(
    `/api/user/${userGUID}/tariff`,
  );
  return unwrap(data);
}
